<template>
  <b-button
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    variant="flat-warning"
    class="btn-icon rounded-circle"
    v-b-tooltip.hover.v-warning.top="$t(i18nHoverVariable)"
    @click="$emit('clicked')"
  >
    <feather-icon icon="PlusSquareIcon" />
  </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'ViewButton',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    i18nHoverVariable: {
      type: String,
      default: "Nuevo",
    },
  },
}
</script>

<style scoped>

</style>
